export function groupPostsReply(posts) {
  const groupedPosts = new Map();
  const originalPosts = new Map();
  
  // First, collect all original posts and replies separately
  posts.forEach(post => {
    if (post.type === 'reply' && post.repostedPost) {
      // Find the root original post id (walk up if replying to a reply)
      let parent = post.repostedPost;
      while (parent && parent.type === 'reply' && parent.repostedPost) {
        parent = parent.repostedPost;
      }
      const postId = parent?.id || post.repostedPost.id;
      const key = `$${postId}`;
      if (!groupedPosts.has(key)) {
        groupedPosts.set(key, { 
          parentPostId: postId,
          postsReply: [], 
          isCarouselReply: true 
        });
      }
      groupedPosts.get(key).postsReply.push(post);
    } else {
      // Store original posts by their ID
      originalPosts.set(post.id, post);
      groupedPosts.set(post.id, post);
    }
  });
  
  // Now create threaded structures for posts that have replies
  const finalPosts = [];
  
  groupedPosts.forEach((item, key) => {
    if (item.postsReply) {
      // This is a reply group, find the original post
      const originalPost = originalPosts.get(item.parentPostId);
      if (originalPost) {
        // Create a threaded post structure
        if (item.postsReply.length === 1) {
          // Single reply - create a simple threaded structure
          finalPosts.push({
            ...item.postsReply[0],
            isReplyThread: true,
            originalPost: originalPost
          });
        } else {
          // Multiple replies - create carousel structure
          finalPosts.push({
            ...item,
            isReplyThread: true,
            originalPost: originalPost
          });
        }
        // Remove the original post since it's now part of the thread
        groupedPosts.delete(originalPost.id);
      } else {
        // No original post found, add replies as standalone
        item.postsReply.forEach(reply => finalPosts.push(reply));
      }
    } else if (typeof item === 'object' && item.id) {
      // This is an original post without replies
      finalPosts.push(item);
    }
  });
  
  return finalPosts.sort((a, b) => {
    // Sort by publish date, newest first
    const aDate = new Date(a.publishedAt || a.originalPost?.publishedAt);
    const bDate = new Date(b.publishedAt || b.originalPost?.publishedAt);
  return bDate.getTime() - aDate.getTime();
  });
}

export function groupPosts(posts) {
  // Modern social media feeds don't group posts into carousels
  // Return posts in chronological order as individual items
  const ts = (p) => {
    const d = p?.publishedAt || p?.createdAt || p?.originalPost?.publishedAt || p?.originalPost?.createdAt;
    const n = typeof d === 'number' ? d : Date.parse(String(d || ''));
    return Number.isFinite(n) ? n : 0;
  };
  return posts
    .filter(post => post && post.id)
    .sort((a, b) => ts(b) - ts(a));
}
